import globalSlice from "./slices/globalSlice";
import { combineReducers } from "@reduxjs/toolkit";

const rootReducer = combineReducers({
  global: globalSlice,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
